export default __webpack_public_path__ + "static/media/renu-logo.ea89f921.jpg";